import { render, staticRenderFns } from "./AdministrativeManagment.vue?vue&type=template&id=de05a966&"
import script from "./AdministrativeManagment.vue?vue&type=script&lang=js&"
export * from "./AdministrativeManagment.vue?vue&type=script&lang=js&"
import style0 from "./AdministrativeManagment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports